import { gql } from "@apollo/client";

export const CAROUSEL_BANNER_CREATE_MUTATION = gql`
  mutation CarouselBannerCreate($input: CarouselBannerInput!) {
    carouselBannerCreate(input: $input) {
      banner {
        id
        title
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const CAROUSEL_BANNER_UPDATE_MUTATION = gql`
  mutation CarouselBannerUpdate($id: ID!, $input: CarouselBannerInput!) {
    carouselBannerUpdate(id: $id, input: $input) {
      banner {
        id
        title
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const CAROUSEL_BANNER_DELETE_MUTATION = gql`
  mutation CarouselBannerDelete($id: ID!) {
    carouselBannerDelete(id: $id) {
      banner {
        id
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const SHORT_VIDEO_CREATE_MUTATION = gql`
  mutation ShortVideoCreate($input: ShortVideoInput!) {
    shortVideoCreate(input: $input) {
      video {
        id
        title
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const SHORT_VIDEO_UPDATE_MUTATION = gql`
  mutation ShortVideoUpdate($id: ID!, $input: ShortVideoInput!) {
    shortVideoUpdate(id: $id, input: $input) {
      video {
        id
        title
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const SHORT_VIDEO_DELETE_MUTATION = gql`
  mutation ShortVideoDelete($id: ID!) {
    shortVideoDelete(id: $id) {
      video {
        id
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const CMS_DELIVERY_SLOT_CREATE_MUTATION = gql`
  mutation CMSDeliverySlotCreate($input: CMSDeliverySlotInput!) {
    cmsDeliverySlotCreate(input: $input) {
      slot {
        id
        slotKey
        label
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const CMS_DELIVERY_SLOT_UPDATE_MUTATION = gql`
  mutation CMSDeliverySlotUpdate($id: ID!, $input: CMSDeliverySlotInput!) {
    cmsDeliverySlotUpdate(id: $id, input: $input) {
      slot {
        id
        slotKey
        label
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const CMS_DELIVERY_SLOT_DELETE_MUTATION = gql`
  mutation CMSDeliverySlotDelete($id: ID!) {
    cmsDeliverySlotDelete(id: $id) {
      slot {
        id
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const CMS_DELIVERY_VACATION_CREATE_MUTATION = gql`
  mutation CMSDeliveryVacationCreate($input: CMSDeliveryVacationInput!) {
    cmsDeliveryVacationCreate(input: $input) {
      vacation {
        id
        date
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const CMS_DELIVERY_VACATION_BULK_CREATE_MUTATION = gql`
  mutation CMSDeliveryVacationBulkCreate(
    $startDate: Date!
    $endDate: Date!
    $label: String
    $deliverySlotIds: [ID!]!
  ) {
    cmsDeliveryVacationBulkCreate(
      startDate: $startDate
      endDate: $endDate
      label: $label
      deliverySlotIds: $deliverySlotIds
    ) {
      vacations {
        id
        date
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const CMS_DELIVERY_VACATION_DELETE_MUTATION = gql`
  mutation CMSDeliveryVacationDelete($id: ID!) {
    cmsDeliveryVacationDelete(id: $id) {
      vacation {
        id
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const SEASONAL_PICK_CREATE_MUTATION = gql`
  mutation SeasonalPickCreate($input: SeasonalPickInput!) {
    seasonalPickCreate(input: $input) {
      seasonalPick {
        id
        label
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const SEASONAL_PICK_UPDATE_MUTATION = gql`
  mutation SeasonalPickUpdate($id: ID!, $input: SeasonalPickInput!) {
    seasonalPickUpdate(id: $id, input: $input) {
      seasonalPick {
        id
        label
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const SEASONAL_PICK_DELETE_MUTATION = gql`
  mutation SeasonalPickDelete($id: ID!) {
    seasonalPickDelete(id: $id) {
      seasonalPick {
        id
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const DELIVERY_LOCATION_CREATE_MUTATION = gql`
  mutation DeliveryLocationCreate($input: DeliveryLocationInput!) {
    deliveryLocationCreate(input: $input) {
      location {
        id
        name
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const DELIVERY_LOCATION_UPDATE_MUTATION = gql`
  mutation DeliveryLocationUpdate($id: ID!, $input: DeliveryLocationInput!) {
    deliveryLocationUpdate(id: $id, input: $input) {
      location {
        id
        name
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const DELIVERY_LOCATION_DELETE_MUTATION = gql`
  mutation DeliveryLocationDelete($id: ID!) {
    deliveryLocationDelete(id: $id) {
      location {
        id
      }
      errors {
        field
        message
        code
      }
    }
  }
`;
